// Export configuration for Licensing Jobs

// Export range for CSV export
export const LICENSING_JOBS_EXPORT_RANGE = "0,999";

// Headers for the export CSV
export const EXPORT_HEADERS = [
  "id",
  "description",
  "catalogs",
  "medias",
  "territories",
  "licenseeTypeList",
  "startDate",
  "endDate",
  "status",
  "lastRun",
  "completedAt",
  "createdBy",
  "createdAt",
  "modifiedBy",
  "modifiedAt",
];

// Renamed headers for display in the CSV
export const EXPORT_RENAMED_HEADERS = [
  "Id",
  "Description",
  "Catalogs",
  "Medias",
  "Territories",
  "Licensee Type",
  "Start Date",
  "End Date",
  "Status",
  "Latest Job",
  "Completed",
  "Created By",
  "Created",
  "Updated By",
  "Modified",
];

/**
 * Transform a licensing job item for export
 * @param {Object} item - The licensing job item
 * @returns {Object} Transformed item for export
 */
export function transformJobForExport(item) {
  return {
    id: item.id,
    description: item.description,
    catalogs:
      item.catalogs?.map((catalog) => catalog.titleWithId).join(" | ") || "",
    medias: item.medias?.map((media) => media.name).join(" | ") || "",
    territories:
      item.territories?.map((territory) => territory.name).join(" | ") || "",
    licenseeTypeList: item.licenseeTypeList?.join(" | ") || "",
    startDate: item.startDate,
    endDate: item.endDate,
    status: item.status,
    lastRun: item.lastRun,
    completedAt: item.completedAt,
    createdBy: item.createdBy?.fullName || "",
    createdAt: item.createdAt,
    modifiedBy: item.modifiedBy?.fullName || "",
    modifiedAt: item.modifiedAt,
  };
}
